import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import PropTypes from "prop-types";
import { PageGridItem } from '../structure/page-blocks';
import { mapPodcastEpisodeToSchema, mapPodcastSeriesToSchema } from './spotify.functions';
import { BlogPostSummary } from './wordpress.components';
import { SchemaPodcastEpisode, SchemaPodcastSeries } from '../foundation/schema';
function getFirstSentences(str, minLength = 300) {
    if (!str)
        return '';
    const firstPeriodIndex = str.indexOf('.', minLength);
    if (firstPeriodIndex !== -1) {
        return str.slice(0, firstPeriodIndex + 1);
    }
    return str;
}
/**
 * Component to display a list of podcast episodes.
 * @param props - The properties for the component, including an array of podcast episodes.
 * @returns A React component that renders a list of podcast episodes.
 */
PodcastEpisodeList.propTypes = {
    episodes: PropTypes.arrayOf(PropTypes.shape({
        title: PropTypes.string.isRequired,
        description: PropTypes.string.isRequired,
        link: PropTypes.string.isRequired,
        guid: PropTypes.string.isRequired,
        creator: PropTypes.string.isRequired,
        pubDate: PropTypes.string.isRequired,
        enclosure: PropTypes.shape({
            url: PropTypes.string.isRequired,
            type: PropTypes.string.isRequired,
            length: PropTypes.string.isRequired,
        }).isRequired,
        summary: PropTypes.string.isRequired,
        explicit: PropTypes.bool.isRequired,
        duration: PropTypes.string.isRequired,
        image: PropTypes.string.isRequired,
        episode: PropTypes.string.isRequired,
        episodeType: PropTypes.string.isRequired,
    }).isRequired).isRequired,
    series: PropTypes.object,
};
export function PodcastEpisodeList(props) {
    const { episodes, series } = props;
    return (_jsxs(_Fragment, { children: [series && _jsx(SchemaPodcastSeries, { series: mapPodcastSeriesToSchema(series) }), episodes.map((episode) => (_jsxs(PageGridItem, { children: [_jsx(SchemaPodcastEpisode, { episode: mapPodcastEpisodeToSchema(episode) }, episode.guid), _jsx(BlogPostSummary, { ID: episode.guid, title: episode.title, date: episode.pubDate, excerpt: getFirstSentences(episode.summary), URL: episode.link, featured_image: episode.image, showCategories: false })] }, episode.guid)))] }));
}
